// extracted by mini-css-extract-plugin
export default {"arrowBackContainer":"styles_arrowBackContainer__4y2Vd"};